export enum RootCategories {
    US = '100',
    CA = '200',
}

export enum RootCategoryNames {
    US = 'US Categories',
    CA = 'CA Categories',
}
